import { Component, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DialogCustomizadoComponent } from 'src/app/components/genericos/dialog-customizado/dialog-customizado.component';
import { JwtService } from 'src/app/jwt.service';
import { SnackbarManager } from 'src/app/managers/snackbar-manager';
import { ConsultaGerencial } from 'src/app/persistences/consulta-gerencial';
import { ConsultaGerencialService } from './../../../services/consulta-gerencial.service';
import { ClienteSingletonService } from './../../../singletons/cliente-singleton.service';
import { ConsultaCustomizadaComponent } from 'src/app/components/genericos/consulta-customizada/consulta-customizada.component';

@Component({
  standalone: false,
  selector: 'app-consultas-gerenciais',
  templateUrl: './consultas-gerenciais.component.html',
  styleUrls: ['./consultas-gerenciais.component.css']
})
export class ConsultasGerenciaisComponent implements OnInit{
  formConsultaGravar: FormGroup;
  formConsultaEditar: FormGroup;
  private consultaGerencialView = new ConsultaGerencial;
  rowHeigthAdicao: number;
  rowHeigthEdicao: number;
  consultasGerenciais: ConsultaGerencial[];
  @Input()
  itemConsultaCdFilial: number;
  @Input()
  itemConsultaCdAcesso: string;
  widthDialog: string;
  isLayoutMobile: boolean;
  consultaGerencialEditado: ConsultaGerencial;
  
  @ViewChild('consultaFilial') consultaFilial: ConsultaCustomizadaComponent;
  @ViewChild('consultaAcesso') consultaAcesso: ConsultaCustomizadaComponent;

  constructor(
    private snackBarManager: SnackbarManager,
    private consultaGerencialService: ConsultaGerencialService,   
    private dialog: MatDialog,
    private jwtService: JwtService,
    private clienteSingletonService: ClienteSingletonService,
  ){ 
  }

  data: Date;

  ngOnInit(): void {  
    this.onResize();
    this.formConsultaGravar = new FormGroup({
      cdFilial: new FormControl('',Validators.required),
      cdAcesso:  new FormControl('',Validators.required),
      ordem:  new FormControl('',[Validators.required, Validators.pattern("^[0-9]*$")]),
      tituloConsulta:  new FormControl('',Validators.required),
      descricao:  new FormControl(''),
      flAtivo:  new FormControl(false)
    });
    
    this.consultaGerencialService.getAllConsultasGerenciais().subscribe(response =>{            
      this.consultasGerenciais = response.map(consulta => {
        const form = new FormGroup({
          cdFilial: new FormControl(consulta.cdFilial, Validators.required),
          cdAcesso: new FormControl(consulta.cdAcesso, Validators.required),
          ordem: new FormControl(consulta.ordem, [Validators.required, Validators.pattern('^[0-9]*$')]),
          tituloConsulta: new FormControl(consulta.tituloConsulta, Validators.required),
          descricao: new FormControl(consulta.descricao),
          flAtivo: new FormControl(consulta.flAtivo)
        });

        return { ...consulta, form };
      });
    }); (error) =>{
      this.snackBarManager.openSnackBar("Não foi possivel carregar paineis: " + error.error, "Ok", 3000);
      console.log(error);
    }
    this.widthDialog = '400px'
  }

  salvar(){
    this.formConsultaGravar.get('cdFilial').setValue(Number(this.itemConsultaCdFilial));
    this.formConsultaGravar.get('cdAcesso').setValue(this.itemConsultaCdAcesso);
    const dtAtz = new Date();
    const flAtivo = this.formConsultaGravar.get('flAtivo').value;

    if (this.formConsultaGravar.valid) {
      this.consultaGerencialView.cdFilial = Number(this.itemConsultaCdFilial);      
      this.consultaGerencialView.dtAtz = dtAtz;
      this.consultaGerencialView.cdAcesso = this.itemConsultaCdAcesso;
      this.consultaGerencialView.ordem = this.formConsultaGravar.get('ordem').value;
      this.consultaGerencialView.tituloConsulta = this.formConsultaGravar.get('tituloConsulta').value;
      this.consultaGerencialView.cdUsuario = this.clienteSingletonService.getClienteEstatico().getCdCliente;
      this.consultaGerencialView.descricao = this.formConsultaGravar.get('descricao').value;
      this.consultaGerencialView.flAtivo = flAtivo != null ? flAtivo : false;
      
      this.consultaGerencialService.salvarConsultaGerencial(this.consultaGerencialView).subscribe(() =>{
        this.snackBarManager.openSnackBar("Consulta gerencial salva com sucesso" , "Ok", 3000);
        this.ngOnInit();

        this.formConsultaGravar.reset();
        this.consultaFilial.limpar();
        this.consultaAcesso.limpar();

        // Limpar variáveis locais
        this.itemConsultaCdAcesso = null;
        this.itemConsultaCdFilial = null;
      }, (error) =>{
        this.snackBarManager.openSnackBar("Não foi possivel salvar a consulta gerencial: " + error.error, "Ok", 3000);
        console.log(error);
      })
    } else {
      this.snackBarManager.openSnackBar("Formulário inválido","Ok", 3000);
    }
    
  }
  
  editar(consultaGerencial:any){  
    const dtAtz = new Date();
    this.consultaGerencialEditado = new ConsultaGerencial();

    this.consultaGerencialEditado.idGeral = consultaGerencial.idGeral;
    this.consultaGerencialEditado.dtAtz = dtAtz;
    this.consultaGerencialEditado.ordem = consultaGerencial.ordem;
    this.consultaGerencialEditado.tituloConsulta = consultaGerencial.tituloConsulta;
    this.consultaGerencialEditado.cdUsuario = this.clienteSingletonService.getClienteEstatico().getCdCliente;
    this.consultaGerencialEditado.descricao = consultaGerencial.descricao;
    this.consultaGerencialEditado.flAtivo = consultaGerencial.form.value.flAtivo;
    
    this.receberItemConsultaFilialEditar(consultaGerencial.form?.get('cdFilial').value, consultaGerencial);
    consultaGerencial.form.get('cdFilial').setValue(this.itemConsultaCdFilial);

    this.receberItemConsultaAcessoEditar(consultaGerencial.form?.get('cdAcesso').value, consultaGerencial)
    consultaGerencial.form.get('cdAcesso').setValue(this.itemConsultaCdAcesso);

    this.consultaGerencialEditado.cdFilial = consultaGerencial.form?.get('cdFilial').value;      
    this.consultaGerencialEditado.cdAcesso = consultaGerencial.form?.get('cdAcesso').value;

    if(consultaGerencial.form?.valid){
      this.consultaGerencialService.atualizarConsultaGerencial(this.consultaGerencialEditado).subscribe(() => {    
        this.snackBarManager.openSnackBar("Consulta gerencial editado com sucesso!" , "Ok", 3000);
        this.ngOnInit();
      }, (error) =>{
        this.snackBarManager.openSnackBar("Não foi possível editar a consulta gerencial: " + error.error, "Ok", 3000);
        console.log(error)
      })
    } else{
      this.snackBarManager.openSnackBar("Formulário inválido","Ok", 3000);
    }

    this.consultaGerencialEditado = null;
    
  }

  async excluir(consultaGerencial: ConsultaGerencial){  
    const mensagem = 'Deseja excluir esta consulta gerencial?';
    const confirmacao = 'Sim';
    const negacao = 'Não';
    
    const dialogRef = this.dialog.open(DialogCustomizadoComponent, {
      width: this.widthDialog,
      height: '100px',
      panelClass: 'custom-dialog',
      data:{labelMensagem: mensagem, labelConfirmacao: confirmacao, labelNegacao: negacao}
    });
    dialogRef.afterClosed().subscribe(
      (result) => {
        if (result) {
          this.consultaGerencialService.deletarConsultaGerencial(consultaGerencial.idGeral).subscribe(() => {            
            this.ngOnInit();
            this.snackBarManager.openSnackBar("Consulta gerencial excluida com sucesso!", "Ok", 3000);
          }, (error) =>{
            this.snackBarManager.openSnackBar("Não foi possível excluir a consulta gerencial: " + error.error, "Ok", 3000);
            console.log(error)
          })
        }
      },
      (error) => {
        this.jwtService.validarAcessToken(error);
      }
    );
  }

  receberItemConsultaFilial(itemConsulta) {
    this.itemConsultaCdFilial = itemConsulta;
  }

  receberItemConsultaAcesso(itemConsulta: string) {
    this.itemConsultaCdAcesso = itemConsulta;
  }

  receberItemConsultaFilialEditar(itemConsulta, consultaGerencial) {
    if(this.consultaGerencialEditado){
      if(consultaGerencial.idGeral == this.consultaGerencialEditado.idGeral){
        this.itemConsultaCdFilial = itemConsulta;
      }else{
        this.itemConsultaCdFilial = consultaGerencial.form.get('cdFilial').value;
      }
    }else{
      this.itemConsultaCdFilial = itemConsulta;
      consultaGerencial.form.get('cdFilial').setValue(itemConsulta)
    }
  }

  receberItemConsultaAcessoEditar(itemConsulta: string, consultaGerencial) {
    if(this.consultaGerencialEditado){
      if(consultaGerencial.idGeral == this.consultaGerencialEditado.idGeral){
        this.itemConsultaCdAcesso = itemConsulta;
      }else{
        this.itemConsultaCdAcesso = consultaGerencial.form.get('cdAcesso').value;
      }
    }else{
      this.itemConsultaCdAcesso = itemConsulta;
      consultaGerencial.form.get('cdAcesso').setValue(itemConsulta)
    }
  }

  selecionarAtivo(flAtivo: boolean){
    this.formConsultaGravar.get('flAtivo').setValue(!flAtivo);
  }

  selecionarAtivoEdicao(consulta: any){
    consulta.form.value.flAtivo = !consulta.form.value.flAtivo
  }

  @HostListener('window:resize')
  onResize(){    
    switch(true){
      case(window.innerWidth < 800):{
        this.isLayoutMobile = true;
        this.rowHeigthEdicao = 635;
        this.rowHeigthAdicao = 600;
        break;
      }
      case(window.innerWidth < 880):{
        this.rowHeigthEdicao = 500;
        this.rowHeigthAdicao = 600;
        this.isLayoutMobile = false;
        break;
      }
      case(window.innerWidth > 880 && window.innerWidth < 1060):{
        this.rowHeigthAdicao = 250;
        this.rowHeigthEdicao = 250;
        break;
      }
      case(window.innerWidth > 1061 && window.innerWidth < 1911):{
        this.rowHeigthAdicao = 250;
        this.rowHeigthEdicao = 250;
        break;
      }
      default:{
        this.rowHeigthAdicao = 200;
        this.rowHeigthEdicao = 140;
      }
    }
  }
}
